import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthContextService } from '@core/auth/context/auth-context.service';
import { APP_CONFIG, AppConfig } from '@core/config/app-config';

function generateCorrelationId(): string {
  return `connect2-${crypto.randomUUID()}`;
}

export const apiInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const appConfig: AppConfig = inject(APP_CONFIG);

  if (!req.url.startsWith(`${appConfig.apiPrefix}/`)) {
    return next(req);
  }

  const authContext = inject(AuthContextService);
  const accessToken = req.headers.get('Authorization') || authContext.getActiveOktaAuth().getAccessToken();

  const headers: Record<string, string> = {
    'correlation-id': generateCorrelationId(),
  };

  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
  }

  const clonedReq = req.clone({ setHeaders: headers });
  return next(clonedReq);
};
